import React, { useContext } from 'react';
import { DContext } from '../../context/Datacontext';
import { Navigate } from 'react-router-dom';

// import your real dashboards (create placeholders if not present)
import { SuperAdminDashboard } from './superadmin/SuperAdminDashboard';
import { AdminDashboard } from './admin/AdminDashboard';


export const Dashboard = () => {
  const { isAuth, currentUser } = useContext(DContext);

  // still loading auth state
  if (isAuth === null) return null;

  // not logged in -> send to login
  if (!isAuth) return <Navigate to="/login" replace />;

  // role-based rendering
  switch (currentUser?.role) {
    case 'superadmin':
      return <SuperAdminDashboard />;
    case 'admin':
      return <AdminDashboard />;
    case 'instructor':
      return <Navigate to='/instructor/dashboard' replace />;
    case 'user':
    case 'student':
      return <Navigate to="/learner/courses" replace />;

    default:
      return <div>Role not assigned or unknown. Contact admin.</div>;
  }
};
